/** A relative, same-origin, internal path only — never an absolute URL or a protocol-relative one
 * (`//evil.com` is parsed by browsers as `https://evil.com`, not a path). This is the open-redirect
 * guard for the `returnTo` query parameter App.tsx attaches before sending an unauthenticated visitor to
 * `/login` — shared by `LoginPage.tsx`'s own post-login navigation and App.tsx's "/login" catch-all route
 * (for an already-authenticated visitor), which apply the identical guard to the identical value. */
export function isSafeReturnTo(value: string | null): value is string {
  if (!value) return false;
  if (!value.startsWith('/')) return false;
  if (value.startsWith('//')) return false;
  if (value.includes('://')) return false;
  return true;
}
